const loca = window.location;
const origin = loca.origin ? loca.origin : `${loca.protocol}//${loca.host}`;

// 钉钉扫码登录相关
const dingdingConfigs = {
  authUrl: 'https://oapi.dingtalk.com/connect/oauth2/sns_authorize',
  local: {
    // AppKey: 'dingxokz6iqrcpzi1wgz',
    AppKey: 'dingnqpefvqqtfoyk8qp',
    RedirectUri: `${origin}/login`,
  },
  dev: {
    AppKey: 'dingxokz6iqrcpzi1wgz',
    RedirectUri: `${origin}/login`,
  },
  test: {
    AppKey: 'dingnqpefvqqtfoyk8qp',
    RedirectUri: `${origin}/login`,
  },
  uat: {
    AppKey: 'ding87ylsmawltk51we5',
    RedirectUri: `${origin}/login`,
  },
  prod: {
    AppKey: 'dingpavgbqy8u6sddew0',
    RedirectUri: `${origin}/login`,
  },
};

export { dingdingConfigs };
